import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MenuItem} from "primeng/api";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {
    OverviewStatisticsBaseComponent
} from "../../../../../../core/shared/overview/overview-statistics-base.component";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../../core/shared/widget/widget-data-param";
import {ObjectRequestListGroupBy} from "../../../../../../core/shared/dto/object/request/object-request-list-group-by";
import {
    ObjectRequestListAttribute
} from "../../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {Sorting} from "../../../../../../core/shared/misc/sorting";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";

@Component({
    selector: 'co-statistics-component',
    templateUrl: 'co-statistics.component.html',
    standalone: false
})
export class CoStatisticsComponent extends OverviewStatisticsBaseComponent implements OnInit, OnChanges, OnDestroy {


    channelTypeContactTypeHistoryWidget: WidgetData;
    channelTypeInternalTypeWidget: WidgetData;
    channelTypePriorityWidget: WidgetData;
    recentlyAddedChannelsWidget: WidgetData;

    items: MenuItem[] | undefined;

    home: MenuItem | undefined;

    constructor(
        private router: Router,
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService) {
        super(route, coreService)
    }

    ngOnInit(): void {


        this.items = [
            {label: 'CO Module'},
        ];

        this.home = {icon: 'pi pi-home', routerLink: '/'};
        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
        this.refreshChannelTypeContactTypeHistoryWidget();
        this.refreshChannelTypeInternalTypeWidget();
        this.refreshChannelTypePriorityWidget();
        this.refreshAddedChannels();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    navigateToConfig() {
        this.router.navigate(['/co/config']);
    }

    refreshChannelTypeContactTypeHistoryWidget() {
        this.channelTypeContactTypeHistoryWidget = WidgetFactory.createWidget(
            'co.overview.channel.type.contact.type.history.widget',
            'Channel Type Contact Type History',
            'history.chart',
            'list',
            'entity.groupBy',
            'co.CoChannelTypeContactType',
            WidgetDataParam.create("fieldCategory", "channelType"),
            WidgetDataParam.create("fieldCategoryCount", "channelType_count"),
            WidgetDataParam.create("historyPeriodMode", "year"),
            WidgetDataParam.create("fieldDate", "createdDate"),
            WidgetDataParam.create("selectionMode", "single"),
            WidgetDataParam.create("size", "S")
        );
        this.channelTypeContactTypeHistoryWidget.dataProviderListRequest = ObjectRequestListGroupBy.create(
            true,
            this.filterCriteria,
            [],
            ["channelType", "createdDate"],
            [new ObjectRequestListAttribute("channelType", "Anzahl", DtoListAttributeRequestAggregateEnum.count)]
        );
    }

    refreshChannelTypeInternalTypeWidget() {
        this.channelTypeInternalTypeWidget = WidgetFactory.createWidgetGroupBy(
            'co.overview.channel.type.internal.type.widget',
            'Channel Type Internal Type',
            'category',
            'entity.groupBy',
            'co.CoChannelType',
            'internalType',
            'internalType_count',
            this.filterCriteria,
            'internalType',
            'Anzahl');
    }

    refreshChannelTypePriorityWidget() {
        this.channelTypePriorityWidget = WidgetFactory.createWidgetGroupBy(
            'co.overview.channel.type.priority.widget',
            'Channel Type Priority',
            'category',
            'entity.groupBy',
            'co.CoChannelType',
            'priority',
            'priority_count',
            this.filterCriteria,
            'priority',
            'Anzahl');
    }

    refreshAddedChannels() {
        this.recentlyAddedChannelsWidget = WidgetFactory.createWidgetTableEntityBasicQl('co.overview.recently.added.channels', 'Recently Added Channel', 'co.CoChannelType', this.filterCriteriaForQuery, [new Sorting('e.createdDate', false)])
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
